var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaologoRFfc26F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFC26F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9403 19C31.7404 19 17 30.9113 17 45.4187C17 54.8867 23.1669 63.133 32.3421 67.867L29.1834 79.6256C29.033 79.931 29.1834 80.3892 29.4842 80.6946C29.6346 80.8473 29.9355 81 30.0859 81C30.2363 81 30.5371 80.8473 30.6875 80.8473L44.0742 71.6847C46.0296 71.9901 47.985 72.1429 50.0907 72.1429C68.2906 72.1429 83.031 60.2315 83.031 45.7241C83.031 30.9113 68.2906 19 49.9403 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaologoRFfc26F);
export default __webpack_public_path__ + "static/media/kakao logo_r__FFC26F.83dfcb5f974d69a44b0573c6222f6d3b.svg";
export { ForwardRef as ReactComponent };